import React from 'react';
export function WhiteLabelSection() {
  return <section className="w-full py-20 md:py-24 relative font-heading overflow-hidden" style={{
    backgroundColor: '#09090B'
  }} data-id="element-753">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-754">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-755">
          {/* Left: Content */}
          <div className="order-2 lg:order-1" data-id="element-756">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-757">
              Votre événement.
              <br data-id="element-758" />
              Votre marque.
              <br data-id="element-759" />
              MeetOS est invisible.
            </h2>
            <p className="text-xl text-white/60 leading-relaxed" data-id="element-760">
              Chaque déploiement MeetOS est entièrement personnalisé — votre
              logo, vos couleurs, votre URL, votre identité. Vos participants ne
              voient jamais MeetOS. Ils voient votre événement.
            </p>
          </div>

          {/* Right: Abstract Mockups */}
          <div className="order-1 lg:order-2 relative h-[400px] md:h-[500px] flex items-center justify-center" data-id="element-761">
            {/* Mockup 1 (Back) */}
            <div className="absolute right-10 md:right-20 top-10 w-[260px] md:w-[320px] h-[340px] md:h-[420px] bg-[#111] border border-white/[0.05] rounded-2xl p-6 shadow-2xl transform rotate-6 opacity-60 transition-transform hover:rotate-12 hover:z-20" data-id="element-762">
              <div className="w-12 h-12 rounded-full bg-rose-500/20 mb-8" data-id="element-763" />
              <div className="w-3/4 h-6 bg-white/[0.08] rounded mb-4" data-id="element-764" />
              <div className="w-1/2 h-4 bg-white/[0.04] rounded mb-12" data-id="element-765" />
              <div className="space-y-4" data-id="element-766">
                <div className="w-full h-12 bg-rose-500/10 rounded-lg border border-rose-500/20" data-id="element-767" />
                <div className="w-full h-12 bg-white/[0.03] rounded-lg" data-id="element-768" />
              </div>
            </div>

            {/* Mockup 2 (Front) */}
            <div className="absolute left-10 md:left-20 bottom-10 w-[260px] md:w-[320px] h-[340px] md:h-[420px] bg-[#0A0A0C] border border-white/[0.1] rounded-2xl p-6 shadow-2xl transform -rotate-3 z-10 transition-transform hover:-rotate-6 hover:scale-105" data-id="element-769">
              <div className="w-12 h-12 rounded bg-emerald-500/20 mb-8" style={{
              clipPath: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)'
            }} data-id="element-770" />
              <div className="w-2/3 h-6 bg-white/[0.1] rounded mb-4" data-id="element-771" />
              <div className="w-1/3 h-4 bg-white/[0.05] rounded mb-12" data-id="element-772" />
              <div className="space-y-4" data-id="element-773">
                <div className="w-full h-12 bg-emerald-500/10 rounded-lg border border-emerald-500/20" data-id="element-774" />
                <div className="w-full h-12 bg-white/[0.04] rounded-lg" data-id="element-775" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}